import {
  locationIdFormat,
  productIdFormat,
  storageLocationIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod";

export const getProductInventoryInBin = {
  name: "getProductInventoryInBin" as const,
  input: z.object({
    locationId: locationIdFormat.schema,
    storageLocationId: storageLocationIdFormat.schema,
    barcode: z.string(),
    enforceLicensePlateScan: z.boolean().optional(),
    overrideStrictLicensePlateScan: z.boolean().optional(),
  }),
  output: z.object({
    product: z
      .object({
        id: productIdFormat.schema,
        title: z.string(),
        imageUrl: z.string().nullish(),
        sku: z.string().nullish(),
        barcode: z.string().nullish(),
        availableQuantity: z.number(),
      })
      .nullable(),
  }),
};
